import { Phone, Mail } from "lucide-react";

export const CtaBand = ({ heading, sub }) => (
  <section data-testid="cta-band" className="relative overflow-hidden rounded-2xl border border-amber-500/25 bg-gradient-to-br from-slate-900 to-slate-950 p-8 sm:p-12 my-16">
    <div className="absolute -top-20 -right-20 h-64 w-64 rounded-full bg-amber-500/10 blur-3xl" />
    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-3 font-heading">{heading}</h2>
    <p className="text-base text-slate-300 leading-relaxed max-w-2xl mb-8">{sub}</p>
    <div className="flex flex-wrap gap-4">
      <a
        href="tel:+18077700243"
        data-testid="cta-call-button"
        className="inline-flex items-center gap-2 rounded-full bg-amber-500 px-6 py-3 text-sm font-bold text-slate-950 transition-all duration-200 hover:bg-amber-400 hover:scale-[1.02]"
      >
        <Phone className="h-4 w-4" /> Call +1 807-770-0243
      </a>
      <a
        href="mailto:admin@1stnation-security.com"
        data-testid="cta-email-button"
        className="inline-flex items-center gap-2 rounded-full border border-amber-500/40 px-6 py-3 text-sm font-semibold text-amber-300 transition-colors duration-200 hover:bg-amber-500/10"
      >
        <Mail className="h-4 w-4" /> Email Us
      </a>
    </div>
  </section>
);
